import { Accordion } from '@base-ui-components/react';
import cx from 'classnames';
import { Icon } from '@components/icon/Icon';
import typography from 'shared/styles/typography.scss';
import type { Faq } from './faq';
import styles from './FAQPage.scss';

interface FAQSectionProps {
  faqs: Faq[];
  sectionName: string;
}

export const FAQSection = ({ sectionName, faqs }: FAQSectionProps) => (
  <section>
    <h2 className={cx(typography.h2, styles.sectionHeading)}>{sectionName}</h2>
    <Accordion.Root keepMounted>
      {faqs.map(({ question, answer }) => (
        <Accordion.Item key={question}>
          <Accordion.Header>
            <Accordion.Trigger
              className={cx(typography.h6, styles.accordionButton)}
            >
              {question}
              <Icon name="chevron" className={styles.chevron} />
            </Accordion.Trigger>
          </Accordion.Header>
          <Accordion.Panel className={cx(typography.t1, styles.accordionPanel)}>
            {/* eslint-disable-next-line react/no-danger */}
            <p dangerouslySetInnerHTML={{ __html: answer }} />
          </Accordion.Panel>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  </section>
);
